/*
* Copyright (C) Regione Lombardia
*/
import { Pipe, PipeTransform } from '@angular/core';
import { AnagraficaComuni } from '@models';

@Pipe({
    name: 'anagraficaComuni',
})
export class AnagraficaComuniPipe implements PipeTransform {

    transform(value: string, items: AnagraficaComuni[]) {
        return items.find(i => i.id === value)?.descrizione || '';
    }

}
